var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("empty", {
    attrs: { message: "此组件为促销预埋组件，展示样式在个性化菜单内配置" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }